import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodsComponent } from './payment-methods.component';



@NgModule({
  declarations:[
    PaymentMethodsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PaymentMethodsComponent
  ]
})
export class PaymentMethodsModule { }
